module.exports = __webpack_public_path__ + "static/media/bulk_msil_vessel_sample.c048b1a4.csv";